import type React from 'react';

interface EventCalendarDayProps {
    dayOfWeek: string;
    day: number;
}

const EventCalendarDay: React.FC<EventCalendarDayProps> = ({ dayOfWeek, day }) => {
    return (
        <div className="event-calendar-day">
            <div className="event-calendar-day-date">
                <span className="event-day-of-week">{dayOfWeek}</span>
                <span className="event-day-number">{day}</span>
            </div>
        </div>
    );
};

export default EventCalendarDay;
